exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#resolve-conflicts[data-v-1c2d184a]{display:flex;position:fixed;z-index:10000;bottom:0;max-width:900px;width:100vw;margin:auto;padding:20px 0}#resolve-conflicts button[data-v-1c2d184a]{margin:auto;box-shadow:0 0 10px var(--color-box-shadow)}\n", ""]);
